import { Button } from "@svea/design-system-components-react";
import { isRequired, Stack, TextField, useText, validateClcCompanyName } from "@sveabank/cc-common";
import { useMemo } from "react";
import { FieldArray } from "react-final-form-arrays";

type Props = {
	onAddNameSuggestion: () => void;
	initialValues?: Array<string>;
};

export const NameSuggestionsField = ({ initialValues, onAddNameSuggestion }: Props) => {
	const [t, texts] = useText();
	const initialFieldValue = useMemo(() => initialValues || [""], []);

	return (
		<Stack gap={2} align="start" fullSize>
			<FieldArray<string> name="proposedCompanyNames" initialValue={initialFieldValue}>
				{({ fields }) => (
					<>
						{fields.map((name, index) => (
							<Stack direction="row" key={name} gap={2} align="start" fullSize>
								<TextField
									fullWidth
									name={name}
									label={`${t(texts.newCompany.companyInfo.nameSuggestions)} ${index + 1}`}
									validators={[isRequired, validateClcCompanyName]}
								/>
								{index > 0 && (
									<Button
										variant="icon"
										icon="trash"
										aria-label={t(texts.common.remove)}
										onPress={() => fields.remove(index)}
									/>
								)}
							</Stack>
						))}
						{!!fields.length && fields.length < 10 && (
							<Button variant="plain" iconStart="plusCircle" onPress={onAddNameSuggestion}>
								{t(texts.newCompany.companyInfo.addNameSuggestions)}
							</Button>
						)}
					</>
				)}
			</FieldArray>
		</Stack>
	);
};
